module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cash-widget",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "cash-widget__icon"
  }, [_vm._v("\n      💵\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cash-widget__content"
  }, [_c('div', {
    staticClass: "cash-widget__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_cash_register')))])]), _vm._v(" "), _c('div', {
    staticClass: "cash-widget__chevron"
  }, [_vm._v("›")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38edd7b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/CashRegisterWidget.vue
// module id = 758
// module chunks = 0